import { StepType } from '@ibe/services';
import Traveler from './Pages/Checkout/Components/Traveler';
import Summary from './Pages/Checkout/Components/Summary';
import Confirmation from './Pages/Checkout/Components/Confirmation/Confirmation';
import { CheckoutStep } from './Models/CheckoutStep';
import Extras from './Pages/Checkout/Components/Extras';
import TravelDate from './Pages/Checkout/Components/TravelDate';
import {
  productIBEWorkflowCheckoutBase,
  productIBEWhitelabelWorkflowCheckoutBase
} from './stepsBase';

export const productIBEWorkflowCheckout: CheckoutStep[] = productIBEWorkflowCheckoutBase.map(
  step => {
    switch (step.type) {
      case StepType.OAG_CHECKOUT_SUMMARY:
        return { ...step, component: Summary };
      case StepType.OAG_CHECKOUT_EXTRAS:
        return { ...step, component: Extras };
      case StepType.OAG_CHECKOUT_TRAVELERS:
        return { ...step, component: Traveler };
      case StepType.OAG_CHECKOUT_CONFIRMATION:
        return { ...step, component: Confirmation };
      default:
        return step;
    }
  }
);

export const productIBEWhitelabelWorkflowCheckout: CheckoutStep[] = productIBEWhitelabelWorkflowCheckoutBase.map(
  step => {
    switch (step.type) {
      case StepType.OAG_PACKAGE_HOTEL:
        return { ...step, component: TravelDate };
      case StepType.OAG_CHECKOUT_SUMMARY:
        return { ...step, component: Summary };
      case StepType.OAG_CHECKOUT_EXTRAS:
        return { ...step, component: Extras };
      case StepType.OAG_CHECKOUT_TRAVELERS:
        return { ...step, component: Traveler };
      case StepType.OAG_CHECKOUT_CONFIRMATION:
        return { ...step, component: Confirmation };
      default:
        return step;
    }
  }
);
